import { render, staticRenderFns } from "./InviteSuccess.vue?vue&type=template&id=c0f25150&scoped=true"
import script from "./InviteSuccess.vue?vue&type=script&lang=js"
export * from "./InviteSuccess.vue?vue&type=script&lang=js"
import style0 from "./InviteSuccess.vue?vue&type=style&index=0&id=c0f25150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f25150",
  null
  
)

export default component.exports